import { defineStore } from "pinia";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    id_usuario: localStorage.getItem("id_usuario") || null,
    id_empleado: localStorage.getItem("id_empleado") || null,
    token: localStorage.getItem("token") || null,
    permisos: JSON.parse(localStorage.getItem("permisos")) || [],
  }),

  actions: {
    async login(email, password, router) {
      try {
        const response = await fetch(
          "https://auth.fmce.com.mx/api/auth/login",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              numEmpleadoEmail: email,
              password,
              appId: 1,
            }),
          }
        );

        if (!response.ok) throw new Error("Error en el login");

        const data = await response.json();

        this.id_usuario = data.user.id_usuario;
        this.id_empleado = data.user.id_empleado;
        this.token = data.token;
        this.permisos = data.user.permisos;

        localStorage.setItem("token", data.token);
        localStorage.setItem("id_usuario", data.user.id_usuario);
        localStorage.setItem("id_empleado", data.user.id_empleado);
        localStorage.setItem("permisos", JSON.stringify(data.user.permisos));

        router.push("/");
      } catch (error) {
        console.error("Error en la autenticación:", error);
        throw error;
      }
    },

    logout(router) {
      this.id_usuario = null;
      this.id_empleado = null;
      this.token = null;
      this.permisos = [];

      localStorage.removeItem("token");
      localStorage.removeItem("id_usuario");
      localStorage.removeItem("id_empleado");
      localStorage.removeItem("permisos");

      router.push("/login");
    },
  },
});
